export const NAME = {
  ADD_EMAIL_FLOW: 'add_email_flow',
  ADD_NEW_WEBSHOP: 'add_new_webshop',
  ADJUSTED_DELIVERY: 'adjusted_delivery',
  ASSIGN_USER_TO_ORDER: 'assign_user_to_order',
  CARRIER_COMPARE: 'carrier_compare',
  DEFAULT_PICKUP_ADDRESS_WARNING: 'default_pickup_address_warning',
  DELETE_USER_CONFIRMATION: 'delete_user_confirmation',
  DIRECT_PRINTING_CONFIGURATION: 'direct_printing_configuration',
  DIRECT_PRINTING_REMOVE_PACKING_TABLE: 'direct_printing_remove_packing_table',
  DIRECT_PRINTING_SHOPS: 'direct_printing_shops',
  COMPOSED_PRODUCTS: 'composed_products',
  EMAIL_PASSWORD_CHECK: 'email_password_check',
  EXTENDED_SEARCH: 'extended_search',
  HOTJAR_FEEDBACK: 'hotjar_feedback',
  LABEL_PRINT: 'label_print',
  ORDER_OVERVIEW_ORDER_LINES: 'order_overview_order_lines',
  ORDER_OVERVIEW_ORDER_NOTES: 'order_overview_order_notes',
  // TODO: OFF-1906 - use this modal name for the cancel modal
  ORDER_OVERVIEW_CANCEL_ORDER: 'order_overview_cancel_order',
  ORDER_IMPORT_ORDER_NOTES: 'order_imports_order_notes',
  PACKAGING_OVERVIEW_DETAILS: 'packaging_overview_details',
  PASSWORD_CHECK: 'password_check',
  REASSIGN_USER_TO_ORDER: 'reassign_user_to_order',
  SUBSCRIPTION_CONFIRMATION: 'subscription_confirmation',
  SUPPORT_CASE_CLOSE: 'support_case_close',
  TRACK_AND_TRACE: 'track_and_trace',
  TWO_FACTOR_AUTHENTICATION_INSTALLATION: 'two_factor_authentication_installation',
  UNASSIGN_USER_FROM_ORDER: 'unassign_user_from_order',
  WOOCOMMERCE_CREDENTIALS: 'woocommerce_credentials',
  LIGHTSPEED_CREDENTIALS: 'lightspeed_credentials',
  PRESTA_CREDENTIALS: 'presta_credentials',
  PRODUCT_IMPORT: 'product_import',
  IMPORT: 'import',
  BATCH_IMPORT: 'batch_import',
  REGISTER_PURCHASE_ORDER: 'register_purchase_order',
  CANCEL_PURCHASE_ORDER: 'cancel_purchase_order',
  DELIVERIES_PRODUCT_CSV_IMPORT: 'deliveries_product_csv_import',
  VETTING: 'vetting',
} as const;
